import React from 'react';
import './App.css';
import Platform from "./newStructure/logic/platform/platform";
import AppWeb from "./newStructure/component/platform/AppWeb";
import AppMobile from "./newStructure/core/platform/mobileApp/AppMobile";


const App = () => {

    if(Platform.isMobile()) {
        return <AppMobile />
    } else {
        return <AppWeb />
    }
}

export default App;
